require('jqmask');

$.validator.addMethod(
  'mobileValidation',
  (value, element) => {
    if ($(element).hasClass('required') === false) {
      return true;
    }

    if (value === undefined || value === null || value === '') {
      return false;
    }
    return (/^\d{10}$/.test(value) === true || /^\d{11}$/.test(value) === true);
  }
);

$.validator.addMethod(
  'phoneValidation',
  (value, element) => {
    if ($(element).hasClass('required') === false) {
      return true;
    }

    let phone = value;
    if (phone === undefined || phone === null || phone === '') {
      return false;
    }

    phone = $.trim(phone.toLowerCase());
    if (/^\d{3}\d{3}\d{4}$/.test(phone) === true || /^\d{2}\d{4}\d{4}$/.test(phone) === true || /^\d{3}\d{4}\d{4}$/.test(phone) === true || phone === '') {
      return true;
    }
    return false;
  },
  '<img src="/img/error-anim.gif"/>'
);

$(() => {
  // $("[data-id='mobile']").mask("09099999999", { placeholder: "" });
  // $("[data-id='tel']").mask("9999999999", { placeholder: "" });
  $("[data-id='zip']").mask('999-9999', { placeholder: '' });
  $("[data-id='email']").removeClass('email');
});

function InitJapanZipFinder() {
  try {
    const id = OCMS.currentForm.FormId;
    const zipVal = OCMS.UltimateForms.get(id).zipField[0].getAttribute('value');

    OCMS.QAS.ZipFinders.register({
      formId: id,
      resources: {
        finderLabel: '郵便番号 *',
        finderButton: '住所を検索',
        resetButton: 'Reset',
        resultLabel: '住所を選んでください',
        skipLabel: '', // "海外から注文の方？",
        skipButton: '', // "国際住所はここに入力"
        value: zipVal || ''
      },
      onSelect(formS, values) {
        if (formS === undefined || formS === null) {
          return;
        }

        formS.address([values[3].address, values[1].address, values[2].address].join('').trim().replace('  ', ''));
        formS.address2(values[0].address);
        formS.city(values[4].address);
        let zip = values[5].address;
        const index = zip.indexOf('〒');
        if (index >= 0) {
          zip = zip.substring(index + 1);
        }
        formS.zip(zip);
        formS.zipContainer.show();
      }
    });
  } catch (e) {
    console.error('JapanZip init failed', e);
  }
}


$(document).on('initialized.ocms.ultimate-form', (event, form) => {
  if (form !== undefined && form !== null &&
  OCMS !== undefined && OCMS !== null &&
  OCMS.QAS !== undefined && OCMS.QAS !== null &&
  OCMS.QAS.ZipFinders !== undefined && OCMS.QAS.ZipFinders !== null) {
    InitJapanZipFinder();

    if (form.addressField.attr('data-hidden') !== 'true') { form.addressContainer.show(); }
    if (form.address2Field.attr('data-hidden') !== 'true') { form.address2Container.show(); }
    if (form.address3Field.attr('data-hidden') !== 'true') { form.address3Container.show(); }
    if (form.address4Field.attr('data-hidden') !== 'true') { form.address4Container.show(); }
    if (form.address5Field.attr('data-hidden') !== 'true') { form.address5Container.show(); }
    if (form.address6Field.attr('data-hidden') !== 'true') { form.address6Container.show(); }
    if (form.address7Field.attr('data-hidden') !== 'true') { form.address7Container.show(); }
    if (form.address8Field.attr('data-hidden') !== 'true') { form.address8Container.show(); }
    if (form.address9Field.attr('data-hidden') !== 'true') { form.address9Container.show(); }
    if (form.cityField.attr('data-hidden') !== 'true') { form.cityContainer.show(); }
    if (form.stateField.attr('data-hidden') !== 'true') { form.stateContainer.show(); }
    if (form.countryField.attr('data-hidden') !== 'true') { form.countryContainer.show(); }
  }
});




// WEBPACK FOOTER //
// ./js/countryForm/japan.form.js